import { cn } from "../../../../lib/utils";

export function Text({ className, ...props }) {
	return (
		<p
			className={cn(
				"text-white m-0",
				["laptop:text-xl laptop:leading-9"],
				["text-lg leading-[32px]"],
				className,
			)}
			{...props}
		/>
	);
}
